import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Campo Instituição: combobox PESQUISÁVEL e EDITÁVEL. Permite selecionar uma instituição
// já cadastrada OU digitar livremente uma nova (nacional ou estrangeira). Não obriga escolher
// da lista e NÃO adiciona automaticamente o texto digitado ao catálogo global.
export function InstituicaoInput({ value, onChange, opcoes = [], testid = "instituicao-input", label = "Instituição", className = "" }) {
  const listId = `${testid}-list`;
  const v = (value || "").trim();
  const near = v ? opcoes.find((it) => (it.nome || "").trim().toLowerCase() === v.toLowerCase() && (it.nome || "").trim() !== v) : null;

  return (
    <div className={`min-w-0 ${className}`}>
      {label !== null && <Label>{label}</Label>}
      <Input
        data-testid={testid}
        list={listId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Selecione ou digite (ex.: PMERJ, Carabineros de Chile)"
        autoComplete="off"
        className="w-full"
      />
      <datalist id={listId}>
        {opcoes.map((it) => <option key={it.id || it} value={it.nome || it} />)}
      </datalist>
      {near && (
        <button
          type="button"
          data-testid={`${testid}-sugestao`}
          onClick={() => onChange(near.nome)}
          className="mt-1 text-xs text-primary hover:underline"
        >
          Já existe "{near.nome}" — usar esta?
        </button>
      )}
    </div>
  );
}
